import React, { useState } from 'react'
import Button from '../../../../../components/inputs/Button';
import { Title, TitleBox, Element } from '../styled';
import FromInput from '../../../../../components/inputs/FromInput';
import { useForm, useFetch } from '../../../../../hooks';


const CompanyName = ({ data, refetchAccount }) => {

    const { doFetch } = useFetch({
        url: `/rpc/setmycowshedname`,
        method: 'POST'
    })

    const [isEditMode, setEditMode] = useState(false);

    const validate = values => {
        return {}
    }

    const save = values => {
        doFetch({
            data: values
        }).then(res => {
            if (res === 1) {
                setEditMode(false)
                refetchAccount();
            } else {
                throw Error(res)
            }
        }).catch(err => {
            console.log(err)
        });
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: save,
        validate: validate,
        initValues: {
            description: data.name
        }
    })

    if (isEditMode) {
        return (
            <TitleBox>
                <form onSubmit={handleSubmit}>
                    <Element>
                        <FromInput
                            type='text'
                            placeholder={data.name}
                            name='description'
                            onChange={handleChange}
                            value={values.description}
                            error={errors.description}
                        />
                    </Element>
                    <Button type="submit" green fullWidth>{data.buttons.save}</Button>
                </form>
            </TitleBox>
        )
    } else {
        return (
            <TitleBox>
                <Title>{data.name}</Title>
                <Button green fullWidth onClick={() => setEditMode(true)}>{data.buttons.edit}</Button>
            </TitleBox>
        )
    }

}

export default CompanyName
